/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { CreateOneBaseAodRulesControllerAodRuleMutationRequest, CreateOneBaseAodRulesControllerAodRuleMutationResponse } from "../models/CreateOneBaseAodRulesControllerAodRule";

export function getCreateOneBaseAodRulesControllerAodRuleUrl() {
  const res = { method: 'POST', url: `/aod-rules` as const }
  return res
}

/**
 * @summary Create a single AodRule
 * {@link /aod-rules}
 */
export async function createOneBaseAodRulesControllerAodRule(data: CreateOneBaseAodRulesControllerAodRuleMutationRequest, config: Partial<RequestConfig<CreateOneBaseAodRulesControllerAodRuleMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, CreateOneBaseAodRulesControllerAodRuleMutationRequest>({ method : "POST", url : getCreateOneBaseAodRulesControllerAodRuleUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}